import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import axios from 'axios';
import { Container, Row, Button, Form, FormGroup, Label, Col, Input } from 'reactstrap';

import { alertActions } from '../../../actions';
import { history} from '../../../_helpers';

class AdminEditUser extends React.Component {
    constructor(props){
        super(props);
        let paramsString = this.props.location.search;
        const params = new URLSearchParams(paramsString);
        const credits = params.get('credits');
        this.state = {
            userId: this.props.match.params.id,
            credits: credits
        }
    }

    onChange = (e) => {
        this.setState({credits: e.target.value});
    }

    saveUser = () => {
        const reg = new RegExp('^[0-9]+$')
        if(reg.test(this.state.credits)){
            axios.post('/api/billing/credits',
                {
                    userId: this.state.userId,
                    credits: this.state.credits
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).then(response => {
                if(response.status === 200){
                    this.props.success('Credits changed!');
                    history.push('/admin');
                } else {
                    this.props.error('There was an error.');
                }
            });
        } else {
            this.props.error('Credits must be a number greater than or equal to 0!');
        }
    }

    render(){
        return (
            <Container>
                <Row>
                    <Col sm="12" md={{ size: 6, offset: 3 }}>
                        <div className="mt2 mb2">
                            <Form>
                                <FormGroup row>
                                    <Label for="exampleEmail">Credits</Label>
                                    <Input type="text" name="credits" id="credits" onChange={this.onChange} value={this.state.credits} />
                                </FormGroup>
                            </Form>
                        </div>
                        <div className="" style={{width: '100%'}}>
                            <div className="fr mb3">
                                <Button className="mr2" color="primary" onClick={this.saveUser}>Save</Button>
                                <Link to='/admin/'>Cancel</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(null, alertActions)(AdminEditUser);


// WEBPACK FOOTER //
// ./src/components/Admin/Users/AdminEditUser.js